import React from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import '../../style/LayersPanel.scss';
import { t } from '../../i18n';

// Liste des modules de la page : retrouver un module caché derrière un autre, le sélectionner, le dupliquer ou le supprimer.
function LayersPanel({ cells, projectId, pageId, selectedId, onDuplicate, onDelete }) {
  if (!cells.length) {
    return (
      <div className='tsk-layers tsk-layers--empty'>
        <FontAwesomeIcon icon={['fas', 'layer-group']} />
        <p>{t('ui.layers.empty')}</p>
      </div>
    );
  }
  return (
    <ul className='tsk-layers'>
      {cells.map((cell, index) => (
        <li key={cell.id} className={cell.id === selectedId ? 'is-selected' : ''}>
          <Link to={`/project/${projectId}/page/${pageId}/cell/${cell.id}`} className='tsk-layers__main'>
            <span className='tsk-layers__index'>{index + 1}</span>
            <span className='tsk-layers__name'>
              <FormattedMessage id={`page.add.cell.button.${cell.cell_type}`} defaultMessage={cell.cell_type} />
            </span>
          </Link>
          <span className='tsk-layers__actions'>
            <button type='button' title={t('ui.common.duplicate')} aria-label={t('ui.common.duplicate')} onClick={() => onDuplicate(cell.id)}>
              <FontAwesomeIcon icon={['fas', 'copy']} />
            </button>
            <button type='button' title={t('ui.common.delete')} aria-label={t('ui.common.delete')} onClick={() => onDelete(cell.id)}>
              <FontAwesomeIcon icon='trash-alt' />
            </button>
          </span>
        </li>
      ))}
    </ul>
  );
}

export default LayersPanel;
